<template>
    <el-container>
        <el-header>
            <div
                style="
          width: 1200px;
          margin: auto;
          display: flex;
          justify-content: space-between;
        "
            >
                <p>
                    <img
                        src="http://www.fulqun.com/images/logo.png"
                        alt
                        style="height: 20px;margin-top: 20px;"
                    />
                </p>
                <div class="menu">
                    <el-menu
                        :default-active="activeIndex"
                        class="el-menu-demo"
                        mode="horizontal"
                        @select="handleSelect"
                    >
                        <el-menu-item index="/home">芙清首页</el-menu-item>
                        <el-menu-item index="/product">产品系列</el-menu-item>
                        <el-submenu index="2">
                            <template slot="title">关于我们</template>
                            <el-menu-item index="/conpany">芙清故事</el-menu-item>
                            <!-- <el-menu-item index="/certification">企业资质</el-menu-item> -->
                            <el-menu-item index="/industry_news">芙清动态</el-menu-item>
                            <el-menu-item index="/contact">联系我们</el-menu-item>
                        </el-submenu>
                        <el-menu-item
                            :index="username ? '' : '/login'"
                            style="font-size: 12px;"
                        >{{ username ? username : '登录' }}</el-menu-item>
                    </el-menu>
                    <el-input
                        style="width: 40%"
                        v-model="inputValue"
                        placeholder="产品搜索"
                        size="mini"
                    ></el-input>
                </div>
            </div>
        </el-header>
        <el-main>
            <router-view></router-view>
        </el-main>
        <!-- <el-footer>Footer</el-footer> -->
    </el-container>
</template>

<script>
export default {
    data() {
        return {
            username: '',
            inputValue: "",
            activeIndex: "1",
        };
    },
    created() {
        if (window.sessionStorage.getItem('username')) {
            this.username = window.sessionStorage.getItem("username");
        } else {
            this.username = null
        }
    },
    methods: {
        handleSelect(key, keyPath) {
            if (key == '/login') {
                this.$router.replace(key);
                return
            }
            this.$router.push(key);
        },
    },
};
</script>

<style lang="less" scoped>
* {
    margin: 0;
    padding: 0;
}

.el-main {
    height: calc(100vh - 60px);
}

.menu {
    width: 60%;
    display: flex;
    justify-content: space-around;
    line-height: 60px;
}

.el-menu {
    border: none !important;
}

.el-menu-demo li {
    margin: 0 10px;
}

.mainbox {
    width: 60%;
    margin: auto;
}

.product {
    list-style: none;
    display: flex;
    justify-content: space-between;
    margin: 20px auto;
}

.product li {
    width: 22%;
    text-align: center;
    padding: 10px;
    border: 1px solid #ccc;
}

.footer {
    height: 200px;
    padding: 30px;
    background-color: rgb(250, 250, 250);
    display: flex;
    justify-content: space-between;
}

.putbox {
    list-style: none;
    font-size: 12px;
    width: 70%;
    margin-top: 10px;
    padding-left: 10%;
    line-height: 30px;
}

.putbox a {
    text-decoration: none;
    color: #666;
}

.contactbox {
    width: 30%;
    height: 100%;
    text-align: center;
    line-height: 50px;
}

.contactbox p:nth-child(1) {
    color: rgb(65, 110, 179);
    font-size: 28px;
}

.contactbox p:nth-child(2) {
    font-size: 14px;
    color: #666;
}

.contactbox p:nth-child(3) {
    width: 180px;
    height: 36px;
    margin: auto;
    border: 1px solid rgb(65, 110, 179);
    color: rgb(65, 110, 179);
    line-height: 36px;
    cursor: pointer;
}
</style>
